import {Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {BaseFormComponent, ValidationError} from 'nc-shared';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'nc-file-upload',
  templateUrl: './nc-file-upload.component.html',
  styleUrls: ['./nc-file-upload.component.scss'],
  providers: [
    {provide: NG_VALUE_ACCESSOR, useExisting: NcFileUploadComponent, multi: true}
  ]
})
export class NcFileUploadComponent extends BaseFormComponent implements OnInit {
  @Input() browseLabel = 'Browse';
  @Output() fileSelectedChanged = new EventEmitter<File>();
  @ViewChild('fileUpload') input;

  constructor(@Inject('ValidationErrorMap') public errorMap: Record<string, ValidationError>) {
    super(errorMap);
  }

  isControlInvalid(): boolean {
    return super.isControlInvalid() && (this.control.touched || this.control.dirty);
  }
}
